import updateSubValuation from '../../../../../Services/updateSubValuation'

export default (guid, field, value) => (dispatch) => {

  dispatch(updateSubValuation(guid, field, value))

}
